module.exports = __webpack_public_path__ + "img/icon-sort-arrow-down.593d2f64.svg";